import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import common from './common'
import quote from './quote'
import account from './account'
import ticket from './ticket'
import news from './news'
import coupon from './coupon'
import errorfield from './errorfield'
import verify from './verify'
import filter from './filter'
import micropolicy from './micropolicy'
import smeQuote from '@/store/smeQuote'
import renewal from './renewal'
import trialCode from './trailCode'
import copy from './copy'
import referBonus from './referBonus'
import request from './httpRequest'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    quote,
    account,
    ticket,
    news,
    coupon,
    errorfield,
    verify,
    filter,
    micropolicy,
    smeQuote,
    renewal,
    trialCode,
    copy,
    referBonus,
    request
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })]
})
